/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailPreview } from './EmailPreview';
import {
    EmailPreviewFromJSON,
    EmailPreviewFromJSONTyped,
    EmailPreviewToJSON,
    EmailPreviewToJSONTyped,
} from './EmailPreview';

/**
 * 
 * @export
 * @interface EmailPreviewResponse
 */
export interface EmailPreviewResponse {
    /**
     * 
     */
    data: EmailPreview;
}

/**
 * Check if a given object implements the EmailPreviewResponse interface.
 */
export function instanceOfEmailPreviewResponse(value: object): value is EmailPreviewResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function EmailPreviewResponseFromJSON(json: any): EmailPreviewResponse {
    return EmailPreviewResponseFromJSONTyped(json, false);
}

export function EmailPreviewResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailPreviewResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmailPreviewFromJSON(json['data']),
    };
}

export function EmailPreviewResponseToJSON(json: any): EmailPreviewResponse {
    return EmailPreviewResponseToJSONTyped(json, false);
}

export function EmailPreviewResponseToJSONTyped(value?: EmailPreviewResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmailPreviewToJSON(value['data']),
    };
}

